import React from 'react';
import Select from 'react-select';

const MultiSelectDropdown = ({ label, options, selectedValues, onChange, isMulti = true }) => {
    return (
        <div className="col-md-3 mb-2">
            <label>{label}</label>

            <Select
                options={options}
                value={selectedValues}
                onChange={onChange}
                isMulti={isMulti}
                closeMenuOnSelect={true}
                placeholder={`Select ${label}`}
                styles={{
                    menu: (base) => ({
                        ...base,
                        zIndex: 9999,
                    }),
                    menuList: (base) => ({
                        ...base,
                        maxHeight: '185px',
                        overflowY: 'auto',
                    }),
                }}
            />
        </div>
    );
};

export default MultiSelectDropdown;
